let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lWHV5")).then(() => parcelRequire('3Htia'));